import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../../config/config";
import {
  FaUser,
  FaUsers,
  FaMedal,
  FaChild,
  FaGift,
  FaMoneyBill,
  FaChartBar,
} from "react-icons/fa";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.6, ease: "easeOut" },
  }),
};

const StatisticsSection = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/stats/get-stats-list`,
          {
            headers: {
              Accept: "text/plain",
              "api-version": "1.0",
            },
          },
        );

        const rawData =
          typeof response.data === "string"
            ? JSON.parse(response.data.trim())
            : response.data;

        setStats(rawData[0]);
      } catch (error) {
        console.error("Error fetching statistics:", error);
      }
    };

    fetchStats();
  }, []);

  if (!stats)
    return <div className="text-center text-white py-5">Loading...</div>;

  const statistics = [
    { icon: <FaUser />, value: stats.averageAge, labelKey: "averageAge" },
    {
      icon: <FaUsers />,
      value: `${stats.population} ${t("million")}`,
      labelKey: "population",
    },
    {
      icon: <FaMedal />,
      value: stats.gdpGrowthRankCis,
      labelKey: "gdpRankCIS",
    },
    { icon: <FaMedal />, value: stats.gdpGrowthRankCa, labelKey: "gdpRankCA" },
    {
      icon: <FaChild />,
      value: `${stats.under35Percent}%`,
      labelKey: "youngPopulation",
    },
    {
      icon: <FaGift />,
      value: `${stats.benefitsCount}+`,
      labelKey: "benefits",
    },
    {
      icon: <FaMoneyBill />,
      value: stats.foreignInvestments,
      labelKey: "foreignInvestment",
    },
    {
      icon: <FaChartBar />,
      value: `${stats.gdpGrowthPercent}%`,
      labelKey: "gdpGrowth",
    },
  ];

  return (
    <div className="py-5" style={{ backgroundColor: "rgba(0, 107, 99, 0.9)" }}>
      <div className="container text-white">
        <h2 className="text-center mb-4">{t("NumbersTJK")}</h2>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-4 text-center">
          {statistics.map((stat, index) => (
            <motion.div
              key={index}
              className="col"
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <div className="d-flex flex-column align-items-center">
                <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                  {stat.icon}
                </div>
                <h4 className="fw-bold">{stat.value}</h4>
                <p className="mb-0">{t(stat.labelKey)}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatisticsSection;
